import React, { Component } from 'react';
import { Button, Form, Grid, Icon, Input, Label } from 'semantic-ui-react';
import { toastr } from 'react-redux-toastr';

class InPlaceFreeFundCode extends Component {
  state = {
    freefundcode: '',
    applied: false
  };

  applyfreefundcode = e => {
    if (e)
      e.stopPropagation();
    const { freefundcode } = this.state;
    const { addMoneyForm, applyFreeFundCode, auth } = this.props;
    if (!!freefundcode) {
      applyFreeFundCode(
        freefundcode,
        addMoneyForm.values && addMoneyForm.values['txn_amount'],
        auth.csrfRequestIdentifier,
        response => {
          if (response.errorCode && response.errors) {
            this.setState({ freefundcode: '' });
          }

          if (response.successMsg === 'success') {
            this.setState({ applied: false });
            this.resetFreefundCode();
          }

          this.toggleForm();
        }
      );
    } else {
      toastr.error('Error', 'Please enter freefund code');
    }
  };

  handleChange = e => {
    this.setState({ freefundcode: e.target.value });
  };

  toggleForm = e => {
    e.stopPropagation();

    //
    this.setState({
      freefundcode: ''
    });

    // toggle show form state
    this.props.toggle();
  };
  resetFreefundCode = e => {
    if (e) e.preventDefault();
    const { freefundcode } = this.state;
    const { resetFreefundCode } = this.props;

    if (!!freefundcode) {
      resetFreefundCode(() => {
        this.setState({ applied: false, freefundcode: '', showForm: false });
      });
    }
  };
  render() {
    const { applied, freefundcode } = this.state;
    const {
      async,
      input,
      width,
      placeholder,
      meta: { touched, error },
      show,
    } = this.props;
    return (
      <Form.Field error={touched && !!error} width={width}>
        <Grid style={{ marginBottom: '10px' }}>
          <Grid.Row>
            <Grid.Column width={16}>
              {!show && !applied && (
                <Button
                  className="floatRight buttonLink"
                  onClick={this.toggleForm}
                  style={{ height: '20px' }}
                >
                  I have freefund code!
                </Button>
              )}
              {applied && (
                <React.Fragment>
                  <Button
                    className="floatRight buttonLink"
                    style={{ height: '20px' }}
                    onClick={this.resetFreefundCode}
                  >
                    {' '}
                    <Label as="a" color="green">
                      Freefund code: {freefundcode}
                      <Icon name="delete" />
                    </Label>
                  </Button>
                </React.Fragment>
              )}
              {show && !applied && (
                <Input
                  {...input}
                  value={freefundcode}
                  placeholder={placeholder}
                  onChange={this.handleChange}
                  onClick={e => {e.stopPropagation()}}
                  onKeyPress={e => {
                    const key=e.keyCode || e.which;
                    if (key === 13) {
                      e.preventDefault();
                      this.applyfreefundcode();
                    }
                  }}
                  error={false}
                  label={
                    <React.Fragment>
                      <Button
                        color="green"
                        icon="check"
                        attached="right"
                        name="promo-code"
                        loading={
                          async.key === 'applyfreefundcode' && async.loading
                        }
                        style={{ borderRadius: 0 }}
                        onClick={this.applyfreefundcode}
                      />
                      <Button
                        color="red"
                        icon="close"
                        attached="right"
                        onClick={this.toggleForm}
                      />
                    </React.Fragment>
                  }
                  labelPosition="right"
                />
              )}
              {touched && error && (
                <Label basic color="red">
                  {error}
                </Label>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Field>
    );
  }
}

export default InPlaceFreeFundCode;
